import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, map, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {PaymentTypeApi} from "@modules/payment/api/payment-type.api";
import {PaymentTypeService} from "@modules/payment/services/payment-type.service";

@Injectable({
  providedIn: 'root'
})
export class PaymentTypeInitializerEffects {
  initPaymentTypes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.paymentTypeApi.get$()),
      tap(paymentTypes => this.paymentTypeService.dispatchSetEntities(paymentTypes)),
      catchError(e => {
        console.error(e);

        this.paymentTypeService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    protected readonly actions$: Actions,
    protected readonly paymentTypeApi: PaymentTypeApi,
    protected readonly paymentTypeService: PaymentTypeService,
  ) {
  }
}
